<div class="page-container">
	<nz-result nzStatus="403" nzTitle="403" nzSubTitle="{{ 'error.forbidden' | translate }}">
		<div nz-result-extra>
			<button nz-button nzType="primary" (click)="navigateBack()">
				{{ 'error.back-to-previous-page' | translate }}
			</button>
		</div>
	</nz-result>
</div>
